import { API_ENDPOINTS } from '../hooks/api';
import { convertMircosecondsToMinutesSeconds } from './time';

export const generateShareUrl = (
  sport,
  matchId,
  part,
  track,
  version,
  startTime,
) => {
  const start = startTime
    ? `start=${convertMircosecondsToMinutesSeconds(startTime)}&`
    : '';
  // eslint-disable-next-line max-len
  return `${window.location.origin}/embed/${sport}/${matchId}/${part}?track=${track}&version=${version}&${start}controls=true&muted=1`;
};
export const generateDownloadUrl = (sport, matchId, part, startTime, endTime) =>
  // eslint-disable-next-line max-len
  `${
    API_ENDPOINTS.videoService
  }/matches/${sport}/${matchId}/videos/${part}/1/1/clip?start_timestamp=${Math.round(
    startTime,
  )}&end_timestamp=${Math.round(endTime)}`;

export default { generateDownloadUrl, generateShareUrl };
